exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-layout-grid{display:grid;grid-auto-flow:row;grid-column-gap:var(--ds-grid-gutter);margin-left:auto;margin-right:auto;max-width:89.5rem;position:relative}.ds-layout-grid--edged{padding-left:var(--ds-grid-gap);padding-right:var(--ds-grid-gap)}@media (min-width:37.5rem){.ds-layout-grid{grid-template:auto/repeat(6,1fr)}.ds-layout-grid--edged{padding-left:var(--ds-grid-gutter);padding-right:var(--ds-grid-gutter)}}@media (min-width:60rem){.ds-layout-grid{grid-template:auto/repeat(12,1fr)}}", ""]);

// exports
exports.locals = {
	"ds-layout-grid": "ds-layout-grid",
	"ds-layout-grid--edged": "ds-layout-grid--edged"
};